export interface InviteDestination {
  roomId: string;
  inviteToken?: string;
}
/** Invite URLs are interpreted only as room identifiers; navigation never follows an untrusted origin. */
export function parseInvite(
  value: string,
  origin = location.origin,
): InviteDestination {
  const input = value.trim();
  if (!input) throw new Error("Paste a room invite first.");
  const url = new URL(
    input.startsWith("/") || /^[a-z]+:\/\//i.test(input)
      ? input
      : `/room/${input}`,
    origin,
  );
  const match = url.pathname.match(/^\/room\/([a-zA-Z0-9_-]{4,64})\/?$/);
  if (!match || !["http:", "https:"].includes(url.protocol))
    throw new Error("That invite doesn’t look right. Copy the full room link.");
  const inviteToken = url.searchParams.get("key") || undefined;
  if (inviteToken && !/^[a-zA-Z0-9_-]{8,256}$/.test(inviteToken))
    throw new Error(
      "That invite key is invalid. Ask your friend for a new link.",
    );
  return { roomId: match[1], inviteToken };
}
/** Stale asynchronous joins must never move a cancelled player into a match. */
export class EntryGeneration {
  private current = 0;
  begin(): number {
    return ++this.current;
  }
  cancel(): void {
    this.current++;
  }
  isCurrent(generation: number): boolean {
    return generation === this.current;
  }
}
